import { Component, OnInit } from '@angular/core';
import { ILoginModel } from '../../model/ILogicModel';
import { FormBuilder, FormGroup } from '@angular/forms';
import { UserService } from '../../provider/user.service';
import { Router } from '@angular/router';
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from 'ngx-toastr';
import { LocalStorageService } from '../../provider/local-storage.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: 'login.component.html'
})
export class LoginComponent implements OnInit {
  login: ILoginModel = {};
  form: FormGroup;
  constructor(private fb: FormBuilder,
    private userapi: UserService,
    private navCtrl: Router,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    private storage: LocalStorageService) { }

  ngOnInit(): void {

    this.storage.getLoggedUser().then(data => {
      if (data) {
        this.navCtrl.navigateByUrl('/dashboard');
      }
    });

    this.form = this.fb.group({
      UserName: [''],
      Password: ['']
    });

  }

  doSave() {

    if (this.form.valid) {
      this.spinner.show();
      this.login = this.form.value;
      this.userapi.userLogin(this.login).subscribe(res => {
        this.spinner.hide();
        if (res.IsSuccess) {
          this.toastr.success('User Logged', 'Successfully');
          this.storage.setLocal(this.storage.authLogin, res.Data);
          this.navCtrl.navigateByUrl('/dashboard');

        } else {
          this.toastr.error('User LogIn ', 'Failed');
        }
      });
    }


  }



}

